import { useState } from 'react';
import PageHeader from '../../../../component/PageHeader';
import { AccommodationBulkImportBreadcrumb } from '../../../../config/BreadcrumbConfig';
import ListComponent from './components/ListComponent';
import { Button } from 'antd';
import BulkImport from '../../Accommodation/components/BulkImport';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import AccommodationSampleFile from '../../../../assets/Property-Template.xlsx';
import ErrorLogComponent from './components/ErrorLogDrawer';

const BulkAccommodation = () => {
	const [accommodationImport, setBulkAccommodationImport] = useState(false);
	const [errorLogModal, setErrorLogModal] = useState(false);

	const addBulkImport = () => {
		setBulkAccommodationImport(true);
	};
	const closeAccommodationImport = () => {
		setBulkAccommodationImport(false);
	};
	const openErrorLog = (errorData) => {
		setErrorLogModal(errorData);
	};
	const closeErrorLog = () => {
		setErrorLogModal(false);
	};

	return (
		<div className="mainPageWrap">
			<PageHeader
				className="mainPageHeader"
				title={AccommodationBulkImportBreadcrumb.title}
				extra={[
					<a
						key={1}
						href={AccommodationSampleFile}
						target="_blank"
						download={'Accommodation-Template.xlsx'}
					>
						<Button type="primary" title={'Download Sample File'}>
							<FontAwesomeIcon icon={faDownload} />
						</Button>
					</a>,
					<Button key={2} type="primary" onClick={addBulkImport}>
						Bulk Accommodation Import
					</Button>,
				]}
			/>
			<ListComponent openLogModal={openErrorLog} />,
			<ErrorLogComponent
				visible={errorLogModal}
				onClose={closeErrorLog}
			/>
			<BulkImport
				visible={accommodationImport}
				onClose={closeAccommodationImport}
			/>
		</div>
	);
};

export default BulkAccommodation;
